const state = {
    permissions: [],
    user: {
        branch_id: null
    },
    isAuthenticated: false,
};

export default state;